import levelUp from '../../assets/images/level_up.svg';
import { Dot } from '../Dot';
import { HeadInfoMessageBG } from '../HeadInfoMessageBG';
import { TextLabelStroke } from '../TextLabelStroke';
import {
	StyledContainer,
	StyledMessageContainer,
} from './HeadInfoLevelUp.styled';

const HeadInfoLevelUp: React.FC = () => {
	return (
		<StyledContainer>
			<HeadInfoMessageBG />
			<StyledMessageContainer>
				<img src={levelUp} />
				<Dot $color={'#FFB500'} $opacity={0.25} style={{ marginTop: 10 }} />
				<TextLabelStroke
					style={{
						fontSize: 20,
						fontWeight: 700,
						color: '#FFB500',
						whiteSpace: 'nowrap',
						marginTop: 20,
					}}
				>
					15 УРОВЕНЬ
				</TextLabelStroke>
				<TextLabelStroke
					style={{
						fontSize: 16,
						fontWeight: 500,
						color: '#FFFFFF',
						whiteSpace: 'nowrap',
						marginTop: 10,
					}}
				>
					Вы получили новый уровень!
				</TextLabelStroke>
			</StyledMessageContainer>
		</StyledContainer>
	);
};

export { HeadInfoLevelUp };
